import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const digitalServicePageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("digitalService"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/digitalService"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
